import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { getAvatar, truncate } from '../../helpers'

interface NewMessageToastProps {
  userId: string
  name: string
  avatar?: string
  gender?: 'male' | 'female'
  text: string
  closeToast?: () => void
}

const NewMessageToast: FC<NewMessageToastProps> = ({
  userId,
  name,
  avatar,
  gender,
  text,
  closeToast,
}) => {
  const navigate = useNavigate()
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => {
        navigate(`/dashboard/messaging?u=${userId}`)
        closeToast?.()
      }}
      className="flex items-center gap-3 cursor-pointer py-0.5"
    >
      <img
        src={getAvatar(gender ?? 'male', avatar)}
        alt={name}
        className="h-11 w-11 shrink-0 rounded-full border-2 border-white object-cover shadow-sm"
      />
      <div className="flex min-w-0 flex-col">
        <span className="flex items-center gap-1.5 text-[13px] font-bold leading-tight text-[#23262E]">
          <i className="fa-solid fa-comment-dots text-[#7885ed]" />
          {name}
        </span>
        <span className="max-w-[220px] truncate text-[12px] text-[#7C7C7C]">
          {truncate(text || 'Vous avez reçu un nouveau message', 60)}
        </span>
        <span className="mt-0.5 text-[11px] font-semibold text-[#7885ed]">
          Voir le message →
        </span>
      </div>
    </div>
  )
}

// Declenche un toast cliquable. Appele depuis le handler socket (mobx, .ts) ;
// la logique JSX reste isolee ici pour rester compilable cote .ts.
export const showNewMessageToast = (params: {
  userId: string
  name: string
  avatar?: string
  gender?: 'male' | 'female'
  text: string
}) => {
  toast(
    ({ closeToast }) => <NewMessageToast {...params} closeToast={closeToast} />,
    {
      autoClose: 6000,
      closeOnClick: false,
      icon: false,
      hideProgressBar: false,
      pauseOnHover: true,
      position: 'top-right',
    }
  )
}

export default NewMessageToast
